export default __webpack_public_path__ + "static/media/abstract.e811e0c9.png";